<template>
    <div class="lifetimeblock-container">
      <!--
      <div class="block-bg">
        <div class="block-bg-image"></div>        
      </div>
      -->
      <div class="main-box page-content-box">
        <BlockTitle
          title="王选生平"
          whiteColor="true"
          channelAlias="shengping"></BlockTitle>
        <div class="brief">
          <span>王选(1937-2006)，男，汉族，江苏无锡人，1937年2月生于上海，少年时代就读于上海南洋模范学校。1958年毕业于北京大学数学力学系，留校后一直从事计算机领域的教学和研究工作。历任北京大学计算机研究所讲师、副教授、教授、博士生导师，副所长、所长。<a :href="getRoutePath('shengpingjieshao')" class="more-info">更多>></a></span>

        </div>
        <div class="channel-list">
          <div class="channel-item">
                  <div class="pic">
                    <a :href="getRoutePath('wangxuannianpu')">
                      <el-image
                        class="cover-img"
                        :src="require('@/assets/img/index-sp-1.jpg')"
                        fit="cover"></el-image>
                    </a>
                  </div>
                  <div class="title">
                    <a :href="getRoutePath('wangxuannianpu')">王选年谱</a>
                  </div>
          </div>
          <div class="channel-item">
                  <div class="pic">
                    <a :href="getRoutePath('yonghengshunjian')">
                      <el-image
                        class="cover-img"
                        :src="require('@/assets/img/index-sp-2.jpg')"
                        fit="cover"></el-image>
                    </a>
                  </div>
                  <div class="title">
                    <a :href="getRoutePath('yonghengshunjian')">永恒瞬间</a>
                  </div>
                </div>
            <div class="channel-item">
              <div class="pic">
                <a :href="getRoutePath('ticishouji')">
                  <el-image                    
                    class="cover-img"
                    :src="require('@/assets/img/index-sp-3.jpg')"
                    fit="cover"></el-image>
                </a>
              </div>
              <div class="title">
                <a :href="getRoutePath('ticishouji')">题词手稿</a>
              </div>
            </div>
        </div>

      </div>
    </div>
</template>
<script>
import BlockTitle from "@/components/blocks/blocktitle";

    export default{
        components: {BlockTitle},
        props:{},
        data(){
            return {};
        },
        methods:{
          getRoutePath(alias){
            return '/shengping?tab=' + alias;
          },
        },
        created(){},
        mounted(){},
    };
</script>
<style scoped>
  .lifetimeblock-container{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    background: url('~@/assets/img/index-bg-shengping.jpg') no-repeat;
    background-size: 100% calc(100% - 160px);
    background-position: center top;
  }

  .block-bg{
    width: 100%;
    height: 500px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 0px;
    background: #003C7C;
    position: absolute;
    top: 10px;
  }

  .block-bg-image{
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 0px;
    background-image: url('../../../assets/img/index-bg-shengping.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

  }

  .main-box{
    /*margin-top: -440px;*/
    padding-top: 60px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    /*gap: 40px;*/
  }

  .brief{
    font-size: 16px;
    font-weight: normal;
    line-height: 32px;
    letter-spacing: 0em;
    color: #FFFFFF;
    width: 85%;
    margin-top: 40px;
  }

  .channel-list{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    padding: 0px;
    /*gap: 75px;*/
    box-sizing: border-box;
    padding: 0 10px;
    margin-top: 40px;
    margin-left: -15px;
    margin-right: -15px;
  }

  .channel-item{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    /*gap: 24px;*/
    flex-grow: 1;
    margin: 0px 15px;
  }
  .cover-img{
    width: 100%;
    height: 100%;    
    overflow: hidden;    
    display:inline-block;    
    transition:all 0.35s ease-in-out;
  }
  
  .cover-img:hover{
    transform: scale(1.1);
    overflow: hidden;
  }
  
  .channel-item .pic{
    box-sizing: border-box;
    /*border: 10px solid #D8DCE2;*/
    overflow: hidden;
    height: 100%;
    width: 100%;
    background: #D8DCE2;
    padding: 10px;
  }

  .channel-item .title{
    font-size: 32px;
    font-weight: normal;
    line-height: 32px;
    letter-spacing: 0em;
    color: #000000;
    margin-top: 24px;
  }
  .more-info{
    color:rgba(216, 220, 226, 0.4) !important;
  }
  .more-info:hover{
    color:rgba(216, 220, 226, 0.8) !important;
  }

@media screen and (max-width: 1000px) {
  .main-box{    
    padding-top: 48px;
    /*gap: 20px;*/
  }
  .block-bg{
    height: 380px;
  }
  .brief{
    margin-top: 20px;
  }
  .channel-list{
    margin-top: 20px;
  }
}  

@media screen and (max-width: 800px) {
  .lifetimeblock-container{    
    background-size: 100% calc(100% - 140px);    
  }
  .channel-list{
    /*gap: 8px;*/
    margin-left: -4px;
    margin-right: -4px;
  }
  .channel-item{
    margin: 0px 4px;
    /*gap: 8px;*/
  }
  .channel-item .title{
    font-size: 16px;
    margin-top: 8px;
  }  
}

@media screen and (max-width: 650px){
  .main-box{    
    /*gap: 16px;*/
    padding-top: 24px;
  }
  .lifetimeblock-container{    
    background-size: 100% calc(100% - 120px);    
  }
  .brief{
    font-size: 14px;
    line-height: 28px;
    margin-top: 16px;
  }
  .channel-list{
    margin-top: 16px;
  }
  .channel-item{
    /*gap: 8px;*/
    flex-grow: 1;  
  }
  .channel-item .title{
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    margin-top: 8px;
  }  
  .channel-item .pic{    
    /*border: 2px solid #D8DCE2;   */
    padding: 2px;
  }
}

@media screen and (max-width: 480px){
  .lifetimeblock-container{    
    background-size: 100% calc(100% - 100px);    
  }
}

@media screen and (max-width: 375px){
  .lifetimeblock-container{    
    background-size: 100% calc(100% - 80px);    
  }
}

@media screen and (min-width: 801px) {
    .channel-list{
    /*gap: 30px;*/
    margin-left: -15px;
    margin-right: -15px;
  }
  .channel-item{
    margin: 0px 15px;
    /*gap: 16px;*/
  }
  .channel-item .title{
    font-size: 24px;
    margin-top: 16px;
  }
}

@media screen and (min-width: 1440px) {
  .channel-list{
    /*gap: 75px;*/
    margin-left: -38px;
    margin-right: -38px;
  }
  .channel-item{
    margin-left: 38px;
    margin-right: 38px;
    gap: 24px;
  }
  .channel-item .title{
    font-size: 32px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/blocks/lifetimeblock/index.vue